export enum BlockType {
    Question = 'QUESTION',
    Content = 'CONTENT',
    Institution = 'INSTITUTION',
    MailAddress = 'MAILADDRESS',
    Group = 'GROUP',
    Conditional = 'CONDITIONAL',
    Activity = 'ACTIVITY',
    Component = 'COMPONENT',
    Tabular = 'TABULAR'
}
